import { render } from "./RecipesList.vue?vue&type=template&id=58757b10"
import script from "./RecipesList.vue?vue&type=script&lang=js"
export * from "./RecipesList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\stick\\projects\\recipe-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__